import {SET_ETAX_TAXPAYER_INFO} from '../../../actionType';

export default function (state={},action){
    switch (action.type) {
        case SET_ETAX_TAXPAYER_INFO:
            return {
                ...state,
                etaxTaxpayerInfo: action.data,
            };
        default:
            return state;
    }
}
